export const getShortPriceList = () => ({
  type: "@saga/GET_SHORT_PRICE_LIST",
});
